// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useState } from "react";

// Layout
import CustomPageLayout from "examples/LayoutContainers/CustomPageLayout";

function DomainStatus() {  
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <CustomPageLayout>
      <MDBox pt={3} pb={3}>
        <Card>
          <MDBox p={3} lineHeight={1}>
            <Grid container justifyContent="space-between" spacing={3}>
              <Grid item xs={12}>
                <MDTypography variant="h5" fontWeight="medium">
                  Domain Status
                </MDTypography>
                <MDTypography variant="button" color="text">
                  Here you can check the status of the domains.
                </MDTypography>
              </Grid>
            </Grid>
            
            <MDBox mt={3}
              width={{
                sm: "100%",
                md: "50%",
              }}>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                textColor="primary"
                indicatorColor="primary"
                variant="fullWidth"
                sx={{
                  "& .MuiTab-root": {
                    height: "35px",
                    fontWeight: "medium",
                  },
                  "& .Mui-selected": {
                    color: "primary.main",
                  },
                }}
              >
                <Tab label="Uptime Robot" />
                <Tab label="AWS CloudWatch" />
              </Tabs>
            </MDBox>
            
            <MDBox 
              mt={2} 
              sx={{
                height: "700px",
                overflow: "hidden",
                position: "relative",
                "& iframe": {
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: "none",
                  borderRadius: "8px",
                  pointerEvents: "auto"
                }
              }}
            >
              {activeTab === 0 && (
                <iframe
                  src={process.env.REACT_APP_UPTIME_ROBOT_STATUS_PAGE_URL}
                  title="Uptime Robot"
                  sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                />
              )}
              {activeTab === 1 && (
                <iframe
                  src={process.env.REACT_APP_CLOUDWATCH_URL}
                  title="AWS CloudWatch"
                  sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                />
              )}
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
    </CustomPageLayout>
  );
}

export default DomainStatus;
